import { FormEvent, useContext, useEffect, useState } from "react"
import { TarefaSelecionada } from "../../interfaces/projetos"
import { Button, Loader } from "../Styles";
import { toast } from "react-toastify";
import { atualizarTarefa } from "../../services/tasks";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { listarMembrosProjeto } from '../../services/projetos';
import { membrosResponsaveis } from '../../interfaces/desafios';
import { useLocation } from 'react-router-dom';

function ModalTarefaNovaEtapa({ tarefaSelecionada, idEtapaSelecionado, atualizarEtapaTarefa }: TarefaSelecionada) {
  const { atualizarDados, modalExibir } = useContext(ModalEstadoContext)
  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");

  const [responsaveis, setResponsaveis] = useState<membrosResponsaveis[]>([]);
  const [responsavel, setResponsavel] = useState(tarefaSelecionada.idResponsavel);
  const [dataEntrega, setDataEntrega] = useState(tarefaSelecionada.dataEntrega);
  const [processando, setProcessando] = useState(false);

  const updateTarefa = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)

    if (!dataEntrega) {
      return toast.warning('Por favor, informe a data de entrega.');
    }
    if (!responsavel) {
      return toast.warning('Por favor, selecione um responsável.');
    }

    const payload = {
      idResponsavel: responsavel,
      dataEntrega,
      idEtapa: idEtapaSelecionado
    }
    try {

      const resposta = await atualizarTarefa(tarefaSelecionada.id.toString(), payload)

      if (resposta.status === 200) {
        setProcessando(false)
        toast.success("Tarefa Atualizada com Sucesso.")
        atualizarDados()
        modalExibir("")
      }
    } catch (error) {
      setProcessando(false)
      toast.error("Erro ao Atualizar Tarefa.")
      return
    }
  }

  useEffect(() => {
    const listarMembrosResponsaveis = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

      try {
        const idProjetoEncoded = encodeURIComponent(idProjeto)
        const resposta = await listarMembrosProjeto(idProjetoEncoded);
        if (resposta.status === 200) {
          return setResponsaveis(resposta.data)
        }

      } catch (error) {
        toast.error("Erro ao listar todos os membros do Projeto.");
      }
    };
    listarMembrosResponsaveis()

  }, [idProjeto])

  return (<div id='fundoModal'>
    <section className="containerModalCentro">
      <span id='novoContainerTitulo'>
        <label>Atualizar Data de entrega da Tarefa</label>
      </span>
      <form id='formModalNovo' onSubmit={updateTarefa}>
        <section>
          <span>
            <label htmlFor="">Responsável</label>
            <select id='responsaveltarefa' value={responsavel} onChange={(e) => setResponsavel(e.target.value)} required>
              {responsaveis.map((responsavel) => (
                <option value={responsavel.usuario.id} key={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
              ))}
            </select>
          </span>
        </section>
        <section>
          <span>
            <label htmlFor="">Data Entrega</label>
            <input type="date" defaultValue={dataEntrega} onChange={(e) => setDataEntrega(e.target.value)} />
          </span>
        </section>
        <span id="botoesContainer">
          <Button type='button' cor='cancelar' isLoading={processando} onClick={() => modalExibir('')}>
            {!processando && 'Cancelar'}
            {processando && <Loader isLoading={processando} />}
          </Button>
          <Button type='submit' cor='salvar' isLoading={processando}>
            {!processando && 'Salvar Dados'}
            {processando && <Loader isLoading={processando} />}
          </Button>
        </span>
      </form>
    </section>
  </div>);
}

export default ModalTarefaNovaEtapa;